// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1lGoI","form":"styles_form__X7cF2"};